import { RestError } from "../services/rest-service/RestService";

export const DEFAULT_CACHE_TIME = 5 * 60 * 1000; // (5 minutes)
export const DEFAULT_KEEP_PREVIOUS_DATA = false;
export const DEFAULT_REFRESH_SECONDS = (15 * 60);

export type BaseUseQueryParameters<T> = {
    cacheTime?: number;
    offline?: boolean;
    enabled?: boolean;
    keepPreviousData?: boolean;
    onSuccess?: (data: T | undefined) => void;
    onError?: (error: RestError) => void;
    refreshSeconds?: number;
    refetchOnWindowFocus?: boolean | 'always';
    staleTime?: number;
};
